import React, { useState } from "react";
import axios from "axios";
import { Loader, Icon } from "semantic-ui-react";

export default function SetCoiButton({
  coiGood,
  contractId,
  dealerVerified,
  showCoi,
  showDealer,
  onSuccess,
}) {
  const [loading, setLoading] = useState(false);

  function onClick() {
    setLoading(true);

    axios
      .post(`/contracts/${contractId}/set-cois/`, { contract_id: contractId })
      .then(() => {
        setLoading(false);
        onSuccess();
      })
      .catch((err) => {
        setLoading(false);
        onSuccess();
      });
  }

  if (!showDealer && !showCoi) return null;

  return (
    <div style={{ display: "flex", alignItems: "flex-start" }}>
      {showDealer && (
        <div style={{ marginRight: "10px" }}>
          <IconBlock
            iconProps={{
              name: dealerVerified ? "thumbs up" : "thumbs down",
              color: dealerVerified ? "green" : "red",
            }}
            message={dealerVerified ? "Dealer Verified" : "Dealer Unverified"}
          />
        </div>
      )}
      {showCoi && (
        <button
          style={{
            padding: "0",
            display: "flex",
            alignItems: "center",
            fontFamily: "inherit",
            textAlign: "center",
            cursor: !coiGood ? "pointer" : "initial",
            outline: "none",
            border: "none",
            background: "transparent",
          }}
          onClick={() => (!coiGood ? onClick() : null)}
          disabled={loading}
        >
          <IconBlock
            iconProps={{
              name: coiGood ? "thumbs up" : "thumbs down",
              color: coiGood ? "green" : "red",
            }}
            message={coiGood ? "COI in compliance" : "COI not in compliance"}
            loading={loading}
            subText={!coiGood ? "(click to refresh)" : null}
          />
        </button>
      )}
    </div>
  );
}

SetCoiButton.defaultProps = {
  dealerVerified: false,
  showCoi: true,
  showDealer: true,
};

const IconBlock = ({ iconProps, message, loading, subText }) => (
  <div
    style={{
      display: "flex",
      flexDirection: "column",
      textAlign: "center",
      justifyContent: "center",
      alignItems: "center",
    }}
  >
    {loading ? <Loader active inline /> : <Icon {...iconProps} />}
    <p
      style={{
        fontSize: "12px",
        fontWeight: "400",
        marginTop: "8px",
      }}
    >
      {message}
      {subText && (
        <React.Fragment>
          <br />
          {subText}
        </React.Fragment>
      )}
    </p>
  </div>
);

IconBlock.defaultProps = {
  subText: null,
};
